import { createEntitySchemas } from '../../../utils/normalize'

export const DOCUMENTS = 'documents'
export const documentsSchemas = createEntitySchemas(DOCUMENTS)
